import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post(
          "/auth/session",
          null,
          {
            headers: { "X-Session-ID": sessionId },
            withCredentials: true,
          }
        );
        await refresh();
        // Clean the URL, then land on the dashboard.
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Welcome, ${data?.user?.name || "friend"}!`);
        navigate("/dashboard", { replace: true, state: { user: data?.user } });
      } catch (err) {
        console.error("Auth exchange failed", err);
        toast.error("Sign-in failed. Please try again.");
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div
      data-testid="auth-callback"
      className="min-h-screen flex flex-col items-center justify-center bg-white"
    >
      <Loader2 className="h-8 w-8 text-brand-blue animate-spin" strokeWidth={2} />
      <p className="mt-4 text-ink-600">Signing you in…</p>
    </div>
  );
}
